{
  "directive": "OD-048 (2026-10-12)",
  "stage": { "w": 941, "h": 1672 },
  "coordinates": "Absolute stage units in Shop's stage-in layer; apply only in the insufficient-balance state.",
  "warn.band": {
    "x": 80,
    "y": 610,
    "w": 780,
    "h": 80,
    "z": 40,
    "fill": { "r": 0, "g": 0, "b": 0, "a": 0.5 },
    "radius": 24
  },
  "warn.text": {
    "x": 134,
    "y": 623,
    "w": 672,
    "h": 54,
    "size": 42,
    "weight": 800,
    "color": "#ffffff",
    "align": "center",
    "fontFamily": "Nunito",
    "lineHeight": 54,
    "letterSpacing": 0,
    "maxLines": 1,
    "z": 46
  },
  "words": {
    "default": "Not enough credits. Buy below.",
    "match": "Need {price} credits. Top up."
  },
  "states": {
    "normal": {
      "warningVisible": false,
      "rowsDy": 0,
      "noteDy": 0,
      "note": "Ordinary shop opening: retain the current layout and reserve no warning space."
    },
    "insufficient": {
      "warningVisible": true,
      "rowsDy": 90,
      "noteDy": 90,
      "rowLane": { "x": 80, "y": 711, "w": 780, "h": 692 },
      "rowTops": [711, 884, 1057, 1230],
      "note": "The existing gap is too short. Move the entire Shop pack lane down 90 units, carrying every row strip, name, subline, price, best-value tag and purchase hit area together. Keep the 173-unit row stride and 169-unit strip height. Move the footer note down 90 units too. Apply each offset once, through the parent lane; do not also offset its children. Title, balance, close control and panel retain their positions."
    },
    "trigger": "Show immediately when a disabled-looking but responsive paid-action button opens the shop because balance is below the action cost: host match start, rematch proposal/sponsorship, paid rematch join, paid public-table join or paid room creation. A nonzero but insufficient balance uses the same warning.",
    "loading_empty_error": "Keep the warning and the insufficient-state offsets while packs load, the catalog is empty, or the shop displays an unavailable/load-error state. Existing status content occupies the shifted pack lane; purchase errors remain in the shifted footer.",
    "checkout_busy": "Keep the warning layout while the existing checkout row dims; retain the shop's current busy interaction rules.",
    "balance_restored": "When a refreshed balance covers the triggering action cost, hide the warning and restore normal offsets. Clear the warning context when this popup closes.",
    "match_copy": "Optional: substitute the total match cost for {price}, not the missing-credit difference. Use plain integer costs 2 through 999999. For a cost of 1 use 'Need 1 credit. Top up.'; for an unknown or longer value use words.default. Show only one sentence in the same lane."
  },
  "rendering": {
    "surface": "Separate translucent overlay above the existing panel; RGB channels are 0..255 and alpha is 0..1. Radius is in stage units. No border or extra glow.",
    "text": "Use the specified Nunito size and weight with a 54-unit line height; vertically center in the lane. Do not let an existing Ink role replace size 42 with its smaller token. No wrapping, compression, ellipsis or font enlargement to fill the lane.",
    "interaction": "The band is informational and has no tap target. Keep the warning text accessible; no intermediate confirmation or extra purchase button."
  }
}
